import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { ButtonProgressComponent } from './button-progress.component';
import { ZefFadeAnimationModule } from '@zerops/zef/animations';

@NgModule({
  declarations: [ ButtonProgressComponent ],
  imports: [
    CommonModule,
    MatProgressBarModule,
    ZefFadeAnimationModule
  ],
  exports: [ ButtonProgressComponent ]
})
export class ButtonProgressModule {

}
